import { Button, Flex, Form, Input, Space, Switch } from 'antd'
import React, { useState } from 'react'
import { FaRegSave } from "react-icons/fa";

function PackingTypeManage({submit, initial = {}}) {
    const [form] = Form.useForm();

    // const [statusValue,]
    const handleSave = () => {
        form.validateFields( ).then( v => {
            if( typeof submit !== "function") return;

            submit( {...initial, ...v, active_status: v.active_status ? 'เปิดการใช้งาน' : 'ปิดการใช้งาน'} );
        })
    }

    const initialValues = {
        active_status: true, // Set the default value for the Switch\
        ...initial
    };

    useState( () => {
        // console.log(initial);
        form.setFieldsValue(initialValues);

    }, []);

    return (
        <div className='packing-type-manage px-0 md:px-5 lg:px-5'>
            <Form layout='vertical' form={form} autoComplete='off'>
                <Space direction='vertical' className='width-100'>
                    <Form.Item label='Packing Type' name='packingtype_name' rules={[ { required: true, message: "Please input your data!", } ]}>
                        <Input placeholder='Enter Packing Type' />
                    </Form.Item>
                    <Form.Item label='Status' name='active_status' valuePropName="checked">
                        <Switch checkedChildren="เปิดการใช้งาน" unCheckedChildren="ปิดการใช้งาน" defaultChecked />
                    </Form.Item>
                    <Flex justify='flex-end'>
                        <div className='flex justify-end'>
                            <Button className='bn-primary bn-center' icon={<FaRegSave className='text-base' />} onClick={()=>handleSave()} >Save</Button>
                        </div>
                    </Flex>
                </Space>
            </Form>
        </div>
    )
}

export default PackingTypeManage